import React, { useEffect, useState } from "react";
import { NAV, LOGO } from "../mock";
import { Menu, X } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";

const Navbar = ({ active }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#2b2b2b]/95 backdrop-blur shadow-lg" : "bg-[#2b2b2b]/85"
      }`}
    >
      <div className="max-w-[1300px] mx-auto px-5 h-[68px] flex items-center justify-between">
        <button onClick={() => go("home")} className="flex items-center gap-3" aria-label="Home">
          <img src={LOGO} alt="Davide Lepido" className="h-8 md:h-9 w-auto" />
        </button>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((item) => (
            <button
              key={item.id + item.label}
              onClick={() => go(item.id)}
              className={`nav-link text-[13px] tracking-wide font-light text-gray-200 hover:text-white ${
                active === item.id ? "active text-white" : ""
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Mobile nav */}
        <div className="lg:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="text-white p-2" aria-label="Menu">
                <Menu size={26} />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#1f1f1f] border-none text-white w-[270px] p-0">
              <div className="flex items-center justify-between px-5 h-[68px] border-b border-white/10">
                <img src={LOGO} alt="Davide Lepido" className="h-7 w-auto" />
                <button onClick={() => setOpen(false)} className="text-white"><X size={24} /></button>
              </div>
              <nav className="flex flex-col py-4">
                {NAV.map((item) => (
                  <button
                    key={item.id + item.label}
                    onClick={() => go(item.id)}
                    className={`text-left px-6 py-3 text-sm tracking-widest font-light hover:bg-white/5 ${
                      active === item.id ? "text-[var(--accent-pink)]" : "text-gray-200"
                    }`}
                  >
                    {item.label}
                  </button>
                ))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
